export default {
  "home": {
    "bannerHeader": "This is how great food makes you feel",
    "bannerSubheader": "Focus on what matters - enjoy the company of your loved ones, have fun and indulge in good food.",
    "customersHeader": "Thousands of people are eating Grain every day and loving it",
    "onlineRestaurantCopy": "Everyday meals. Delivered to your doorstep.",
    "cateringCardCopy": "Catered food. Designed to impress.",
    "onlineRestaurantCTA": "Browse menu ❯",
    "cateringCTA": "Browse menu ❯",
    "bestThing": '"The best thing since sliced bread"',
    "healthyFoodHeader": "Healthy and tasty food",
    "healthyFoodSubheader": "We use high-quality and nutritious ingredients, with more spices and less seasoning.",
    "bestInClassHeader": "Best-in-class service",
    "bestInClassSubheader": "We take pride in giving the kind of customer service that we would like to receive ourselves.",
    "changingMenuHeader": "Changing menu by in-house chefs",
    "changingMenuSubheader": "Our chefs constantly innovate to keep our menu exciting and fresh for everyone.",
    "motherEarthHeader": "Caring for Mother Earth",
    "motherEarthSubheader": "We use environmentally sustainable packaging and ingredients. Technology helps us optimise food production and reduce wastage."
  },
  "businessUnit": {
    "onlineRestaurantCaps": "ONLINE RESTAURANT",
    "onlineRestaurant": "Online restaurant",
    "cateringCaps": "CATERING",
    "catering": "Catering"
  },
  "menu": {
    "mainHeader": "Eat better together",
    "mainSubHeader": "Our food tastes even better when you enjoy it in the company of your loved ones.",
    "mainHeaderPell": "This giveaway might be your cup of tea",
    "mainSubHeaderPell": "Place your online restaurant order for Sep 2–30 and get one can of Sanpellegrino +Tea — an organic, lightly carbonated tea — for free. No promo code required.",
    "sharedMealsHeader": "Shared meals",
    "sharedMealsSubtext": "Set meals thoughtfully put together for sharing",
    "highlightHeader": "Highlights",
    "highlightSubtext": "Latest inspirations from our chefs",
    "mealBoxesHeader": "Regulars",
    "mealBoxesSubtext": "Meals you can enjoy day in day out",
    "ancillaryHeader": "Sides, desserts and drinks",
    "ancillarySubtext": "Complements to the perfect meal",
    "sidesHeader": "Sides",
    "sidesSubtext": "Small dishes to complement your meal",
    "dessertsHeader": "Desserts",
    "dessertsSubtext": "Treats for life’s simplest pleasures",
    "drinksHeader": "Drinks",
    "drinksSubtext": "Thirst quenchers without the extra calories",
    "notOpen": "We are not open on this date."
  },
  "menu_subnav": {
     "deliveryTo": "Deliver to",
     "serveOn": "Serve on",
     "serveAt": "at",
     "noLimitExtended": "There is no order limit for each person.",
     "limitIs": "The order limit for each person is "
  },
  "date_time_selector": {
     "selectADate": "Select a date",
     "selectDeliveryTimeslot": "Select a delivery time slot",
     "lunch": "LUNCH",
     "dinner": "DINNER",
     "lunchLastOrderTime": "(Last orders at 1:25pm)",
     "dinnerLastOrderTime": "(Last orders at 8:55pm)"
  },
  "address_selector": {
    "selectDeliveryAddress": "Select a delivery address",
    "addNewAddress": "Add a new address",
    "viewCart": "View cart"
  },
  "different_address": {
    "header": "We sense a disturbance in the force",
    "savedAddress": "Your current default address is <strong>{defaultAddress}</strong>.<br><br>Would you like to change to <strong>{changeAddress}</strong> instead?",
    "newAddress": "Your current default address is <strong>{defaultAddress}</strong>.<br><br>Would you like to add and default to <strong>{changeAddress}</strong> instead?"
  },
  "single_side_cart": {
    "header": "Your cart",
    "inviteFriends": "Invite friends to your group order",
    "inviteFriendsButton": "Invite friends",
    "emptyState": "Hmm... your cart is empty.<br>How about adding some meals before checking out?",
    "subtotal": "Subtotal:",
    "yourOrder": "Your order",
    "cutoffTime": "We're closed for today.",
    "lunchCutOffText": "Orders for lunch close at {time}.",
    "dinnerCutOffText": "Orders for dinner close at {time}.",
    "orderForDinner": "How about ordering for dinner?",
    "showTomorrowsMenu": "Show tomorrow's menu",
    "seeNextAvailableTime": "See next available menu",
    "nonLoggedIn": "Log in or sign up to<br>add items to cart.",
    "logIn": "Log in",
    "delivery": "Delivery",
    "switchToPickupFree": "Switch to pickup for free",
    "switchToDeliveryAt": "Switch to delivery at",
    "minOrderSurcharge": "Surcharge",
    "orderSurchargeText": "Applied to orders under ",
    "cartTotal": "Total (w/ GST)",
    "orderLimitExceeded": "Order exceeds {amount} limit.",
    "weAreOutOfStock": "We're out of stock.",
    "cartLocked": "Your order is locked to prevent others from adding items to cart.",
    "unlockCart": "Unlock",
    "weAreBusy": "All our time slots are busy at the moment.",
    "weAreBusyLunch": "All our lunch time slots are busy at the moment.",
    "weAreBusyDinner": "All our dinner time slots are busy at the moment.",
    "contactUsLink": "Contact us",
    "contactUsBody": "if you have any questions.",
    "unavailableTimeslot": "Selected delivery time slot is no longer available.",
    "checkout": "Go to checkout",
    "go_to_checkout": "Go to checkout",
    "lunchNotAvailable": "Lunch is currently not available at your location",
    "dinnerNotAvailable": "Dinner is currently not available at your location"
  },
  "checkout_modal": {
    "header": "Checkout",
    "unexpectedError": "An unexpected error has occurred. Please try again later.",
    "emptyCartHeader": "Oh no, it seems your cart is empty.",
    "emptyCartBody": "Please add some items to your cart.",
    "minimumNotMetHeader": "Oh no, it seems your cart does not meet the minimum order.",
    "minimumNotMetBody": "Please add more items to your cart to complete order.",
    "deliveryLabel": "Delivery",
    "deliveryDescription": "Orders are delivered to your doorstep",
    "pickupLabel": "Collect from a pickup point",
    "deliveryInstructionsHeader": "Delivery instructions",
    "deliveryInstructionsSubheader": "Anything you would like us to take note of?",
    "deliveryInstructionsPlaceholder": "Leave my food by my doorstep.",
    "addInstructions": "Add delivery instructions",
    "includeUtensils": "Include utensils?",
    "updateDeliveryInstructionsAction": "Save",
    "noPromotionForTeams": "*Promotions are not applicable for Grain for Teams orders",
    "enterPromoCode": "Enter promo code",
    "applyPromoCodeAction": "Apply",
    "subtotalLabel": "Subtotal",
    "deliveryFeeLabel": "Delivery fee",
    "minimumOrderSurchargeLabel": "Surcharge",
    "discountsLabel": "Discounts",
    "useCreditsLabel": "Use Grain credits",
    "totalLabel": "Total (w/ GST)",
    "includesGstLabel": "Price payable includes GST",
    "checkoutAction": "Confirm and place order",
    "payWithCard": "Pay with credit or debit card",
    "checkoutProcessingAction": "Processing",
    "promotionValidationError": "{error}",
    "teamsOrderLabel": "Make this a Grain for Teams order",
    "teamsOrderDescription": "Your orders will be billed at the end of the month",
    "processingOrderLabel": "We are processing your order..."
  },
  "group_order_modal": {
    "inviteFriends": "Invite friends to your group order",
    "linkGenerated": "A link will be generated for you to share with your friends.",
    "shareLink": "Share the link below with your friends to invite them to join in your order.",
    "copyLink": "Copy",
    "orderValueLimitHeader": "Order limit",
    "orderValueLimit": "Set an order limit for each person:",
    "startGroupOrder": "Start group order",
    "newOrderValueLimit": "Set new order limit for each person:",
    "saveChanges": "Save changes"
  },
  "delete_group_cart": {
    "cancelGroupOrder": "Are you sure you want to proceed?",
    "cancellingYourGroupOrder": "You are about to cancel your group order. This action will clear your entire group cart."
  },
  "invite_modal": {
    "shareLinkWithFriends": "Share link with your friends"
  },
  "leave_modal": {
    "leaveCartHeader": "Are you sure you want to proceed?",
    "leaveCartBody": "You are about to leave {ownerName}'s group order. This action will remove all your items from the cart. You can rejoin this group order by visiting the group ordering link again.",
    "cancel": "Cancel",
    "proceed": "Proceed",
    "cartLockedHeader": "{ownerName} has finalised the group order.",
    "cartLockedBody": "You cannot leave the group order while {ownerName} is checking out. Contact {ownerName} if you need to change your order.",
    "close": "Close"
  },
  "group_order_member_entry": {
    "joinGroupOrder": "Join group order"
  },
  "login_modal": {
    "loginOrSignup": "Log in or sign up to continue adding items to cart.",
    "notLoggedIn": "You are not logged in"
  },
  "alert_modal": {
    "changeServingDate": "Are you sure you want to change your serving date?",
    "clearChangedDate": "Your cart will be cleared. Do you wish to proceed?"
  },
  "out_of_stock_alert": {
    "header": "Some items are not available.",
    "description": "Change order quantity or pick another item from the menu?"
  },
  "order_status": {
    "loading": "Loading...",
    "error": "Oops!<br>Something went wrong when attempting to track your order",
    "tooEarly": "Tracking for this order will be available on {servingDate}",
    "confirmed": "Your order will be delivered between",
    "assigned": "Your order has been assigned to be delivered between",
    "onTheWay": "Your order will arrive in",
    "arriving": "Your order is arriving in",
    "late": "Your order is running late.<br>It will arrive in",
    "failed": "We couldn't deliver your order for some reason",
    "delivered": "Your order was successfully delivered on {servingDate}",
    "cancelled": "Your order was cancelled",
    "labelConfirmed": "Order confirmed",
    "labelAssigned": "Order assigned",
    "labelOnTheWay": "Order is on the way",
    "labelArriving": "Order is arriving",
    "labelDelivered": "Order delivered",
    "labelLate": "Order is on the way",
    "labelFailedHeader": "Delivery was unsuccessful",
    "labelFailedBody": "Please contact our customer care team at {contact_number} for assistance."
  },
  "no_delivery": {
    "notAvailableAtLocation": "We are currently not serving your location"
  },
  "christmas": {
    "bannerHeader": "Legend has it that wishing upon a shooting star makes your wish come true…",
    "bannerSubheader": "This Christmas, tell us your wish and we might just turn it into reality, making you the happiest human on planet Earth.",
    "wishOver": "Thank you for sharing with us all your wishes.",
    "noWishSubheader": "The wishing period has ended and the Christmas elves are busy picking the winners.<br/>Watch this space for the list of wishes that have come true.",
    "stepOne": 'Place your order',
    "stepOneDetails": 'Order from our <a href="/eat">online restaurant</a> or <a href="/catering">catering</a>. We will drop an enchanted wish card into every meal box and catering order delivered from <b>Dec 3 – Dec 9.</b>',
    "stepTwo": 'Make your wish',
    "stepTwoDetails": 'Write down your Christmas wish on this card. To fly a Boeing 737 aircraft, be a superhero or spend a day with exciting activities planned out for you — whatever it is, we will do our best to make it happen.',
    "stepThree": 'Post it on Instagram',
    "stepThreeDetails": 'Take a photo of this card, and post it on Instagram with a creative caption and hashtag <b>#WishUponAGrain</b> before <b>Dec 9, 11:59PM</b>. Remember to set your profile to public.',

    "12Wishes": "We will be granting 12 Christmas wishes",
    "wishComeTrue": "If your wish is on our list, you will be notified via Instagram direct message on <b>Dec 11.</b><br/><br/>Now place your order and start wishing.",
    "browseOnlineRestaurant": "Browse online restaurant menu",
    "browseCatering": "Browse catering menu",
    "faqHeader": "Frequently asked questions",
    "questionOne": "Can I send the photo directly to you instead?",
    "answerOne": "As much as we love receiving photos from our customers, Santa doesn't allow it. Like everyone else, kindly post your photo on Instagram.",
    "questionTwo": "How do I know if you have seen my wish?",
    "answerTwo": "We will give a like and leave a comment on every Instagram post to let you know. If we don't do that within 24 hours, just bug us via Instagram direct message.",
    "questionThree": "When will you grant my wish?",
    "answerThree": "All wishes will be granted from Dec 14 to Christmas Day.",
    "questionFour": "Is there anything else I need to do?",
    "answerFour": "When we grant your wishes, we will be taking photos of you and your gift or experience. By taking part in #WishUponAGrain, you give us the permission to use your photos on our collaterals.",
    "questionFive": "Will I see Santa?",
    "answerFive": "Of course, if you ask.",
    "questionSix": "Can I wish for a million dollars?",
    "answerSix": "Yes you can, just don't indicate the currency.",
    "questionSeven": "Can I wish for more wishes?",
    "answerSeven": "Haha, nice try."
  }
}
